/**
 * AdminOrcaRecoverRpcClient - AtomRpc integration for admin orca recover endpoints
 *
 * Requires admin authentication via Clerk session token.
 *
 * @since 1.0.0
 */
import { AtomRpc } from "@effect-atom/atom-react";
import { FetchHttpClient } from "@effect/platform";
import { RpcSerialization } from "@effect/rpc";
import { AdminOrcaRecoverRpcs } from "@fm/api/rpc";
import { Layer } from "effect";
import { makeRpcClientLayer, makeTokenGetterLayer } from "./shared.ts";

export class AdminOrcaRecoverRpcClient extends AtomRpc.Tag<AdminOrcaRecoverRpcClient>()(
  "AdminOrcaRecoverRpcClient",
  {
    group: AdminOrcaRecoverRpcs,
    protocol: makeRpcClientLayer(AdminOrcaRecoverRpcs).pipe(
      Layer.provide(RpcSerialization.layerNdjson),
      Layer.provide(makeTokenGetterLayer()),
      Layer.provide(FetchHttpClient.layer),
    ),
  },
) {}
